import React from 'react';
import ValueSource from '../../../../sources/value';
import FlowSource from '../../../../sources/flow';
import InputOutputValues from './InputOutputValues';
import Loader from '../../../Loader';

import { addNotification } from '../../../../actions/reduxActions/notification';
import { matchAllSubFlowArguments } from './subflowUtils';
import { connect } from 'react-redux';
import { ACCESS_LEVELS } from '../../../../constants';

/**
 * @param {String} flowId
 * @param {String} subFlowId
 * @param {Array} subFlowArguments The raw arguments metadata for the subflow map element
 * @param {Array} subFlowArgumentsToBeRendered The subflow arguments formatted as such to tell
 * the UI how to render the argument e.g how to display the value selector etc
 *
 * @param {Function} setSubFlowArguments Callback for setting arguments in the root components state
 * @param {Function} onSelect Callback for updating a single argument
 * @param {Function} togglePicker Callback to trigger opening/closing the value picker modal
 * @param {Boolean} isLoading Determines whether to show a loading indicator
 * @param {Boolean} isMatching Determines whether to set the matching checkbox to checked/unchecked
 * @param {Function} onMatch Callback for setting subflow arguments in root component state
 * after arguments have been matched
 *
 * @description Renders a UI for displaying subflow arguments
 * across all value access type (input, output, input_output).
 * Displays a checkbox to match/unmatch vales to be passed
 * in/out of the subflow.
 */
export class SubFlowArguments extends React.Component {

    state = {

        /**
         * We need to set all value references available inside the tenant
         * into state as they are used for mapping the "value to be passed"
         * part of the subflow argument when we need to match arguments
         */
        valueReferences: [],

        /**
         * We also need all of the values that have been imported into the
         * Flow, as we need to check that they have been imported when doing
         * the auto matching.
         */
        valuesInParentFlow: [],
        isFetchingValues: true,
    }

    componentDidMount() {
        this.fetchValues();
    }

    fetchValues = async () => {
        const { authenticationToken, tenantId, addNotification: displayError, flowId } = this.props;

        try {
            const valueReferences = await ValueSource.getList(authenticationToken, tenantId, null);
            const valuesInParentFlow = await FlowSource.getFlowSharedElements(flowId, 'value', tenantId, authenticationToken);
            this.setState({ valueReferences, valuesInParentFlow, isFetchingValues: false });

        } catch ({ message }) {
            displayError({
                type: 'error',
                message,
                isPersistent: true,
            });
        }
    }

    render() {
        const { subFlowArgumentsToBeRendered } = this.props;
        const { valueReferences, valuesInParentFlow, isFetchingValues } = this.state;
        return (
            <>
                {isFetchingValues ? <Loader /> :
                <>
                    <div>
                        <button
                            className="btn btn-default match-args"
                            onClick={() => matchAllSubFlowArguments(
                                valueReferences,
                                this.props.onMatch,
                                subFlowArgumentsToBeRendered,
                                valuesInParentFlow,
                            )}
                        >
                            Auto match all value arguments
                        </button>
                    </div>

                    <InputOutputValues
                        valueReferences={valueReferences}
                        access={ACCESS_LEVELS.INPUT.value}
                        {...this.props}
                    />

                    <InputOutputValues
                        valueReferences={valueReferences}
                        access={ACCESS_LEVELS.OUTPUT.value}
                        {...this.props}
                    />

                    <InputOutputValues
                        valueReferences={valueReferences}
                        access={ACCESS_LEVELS.INPUT_OUTPUT.value}
                        {...this.props}
                    />

                    <InputOutputValues
                        valueReferences={valueReferences}
                        access={ACCESS_LEVELS.PUBLIC.value}
                        {...this.props}
                    />
                </>}
            </>
        );
    }
}

const mapStateToProps = ({ currentUser }) => ({
    authenticationToken: currentUser.authenticationToken,
    tenantId: currentUser.tenantId,
});

const mapDispatchToProps = {
    addNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubFlowArguments);
